import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const serpentSB4001: IProductData = {
  id: "serpent-sb4001",
  name: "Serpent Audio SB4001",
  description: "500 Series Stereo Bus Compressor Module",
  images: ["/img/serpent_sb4001_front.jpg", "/img/serpent_sb4001_left.jpg"],
  details: [{
    label: "Description",
    markdown: `
The SB4001 pushes the limits and sets new standards for the 500 Series Format. 
Boasting Quad VCA’s, 6 ratio’s, 10 Attack Times, High Pass/Boost/Slope Sidechain Filters, Wet/Dry Blend Control, External (Key) Input, Classic Stepped Release Settings, Classic And Alternate Auto Release, Variable Release Control, as well as “Grind” Mode (a proprietary valve style harmonic drive adding vintage color), the SB4001 is capable of delivering whatever sound you need. 
Whether Clean, Dirty, Vintage, Subtle, or Crushed, the SB4001 is sure to be one of the most flexible compressors in your arsenal.
`
  }, {
    label: "Overview",
    markdown: `
- Made in the City of Brotherly Love: Philadelphia, USA.
- Quad VCA’s (For Superior Dynamic Range)
- Electronically Balanced
- True Bypass (Relay Controlled)
- Protection From 48V Phantom Power
- Powder Coated Front Panel For Extra Durability.
- All Hand Made Thru Hole Main Audio Path
- Ratios – 1.5,2,4,6,8,10

- Attack Times (Stepped) – .1,.3,1,3,5,10,15,20,25,30,40,50
- Release Times (Stepped) – .3,.6,1.2, Classic Auto release (A1), Alternate Auto Release (A2)
- Release Times (Variable – Engaged By Last Position On Stepped Switch) – Any Time From .1 Sec to 1.2 Sec
- Sidechain Filters – 60Hz, 90Hz, 120Hz, Boost Mode, Slope Mode
- Wet/Dry Blend (For Parallel Processing)

- “Grind” Mode – Special Valve Style Harmonic Drive Mode, adding vintage color
- External/Key Input – Accepts Balanced or Unbalanced Inputs (inserted before sidechain filters)
- Gain (-6 to +18)
- Premium Grayhill Rotary Switches
- Premium Sealed Pots
- All Machined Aluminum Knobs
    `
  }, {
    label: "Specifications",
    markdown: `
- Input: 22KHz Input Impedance, Electronically Balanced (Accepts Balanced or
- Unbalanced Signals)
- Output: <100 Ohm Output Impedance, Transformer-like Floating Output,
- Electronically Balanced (Accepts Balanced or Unbalanced Signals)
- External In: 22KHz Input Impedance, Electronically Balanced (TRS), (Accepts
- Balanced or Unbalanced Signals)
- Maximum Input Level: +21dbu
- Maximum Output Level: +21dbu
- Maximum Output Load: 600 Ohm
- Gain: 24db (+/-1dbu) [-6 to +18]
- Gain Reduction Element: Quad VCA
- Frequency Response: (20Hz-20KHz) +/-0.11dB
- THD+N: (20Hz-20KHz) Typically 0.008%
- Noise Floor: -100dbu
- Dynamic Range: >119db
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://serpentaudio.com/sb4001/" target="_blank">https://serpentaudio.com/sb4001/</a>
- <a to="https://serpentaudio.com/wp-content/uploads/2016/12/sb4001_v1.5_manual.pdf" target="_blank">576 Manual</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.COMPRESSOR, HASHTAGS.SINGLE_SLOT, HASHTAGS.MASTERING, HASHTAGS.API_500],
    manufacturer: BRAND.SERPENT,
  }
}